import { render, staticRenderFns } from "./AmountSelector.vue?vue&type=template&id=2480dc54&"
import script from "./AmountSelector.vue?vue&type=script&lang=js&"
export * from "./AmountSelector.vue?vue&type=script&lang=js&"
import style0 from "./AmountSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports